import React, { useEffect, useRef, useState } from "react";
import BreadCrumbLayout from "../../../../components/common/BreadCrumbLayout";
import { Link } from "react-router-dom";
import downDrop from "../../../../assets/arrow_drop_down.png";
import ActionImg from "../../../../assets/CAction.png";
import { Tooltip } from "antd";

const ARHeaderActions = ({
  isReportReady,
  handleDownloadExcel,
  handlePrintDetails,
  setShow,
  fromUrl,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const exportRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (exportRef.current && !exportRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="d-flex align-items-end justify-content-between mb-3 no-print pt-0">
      <div className="rbar d-flex align-items-center px-2">
        <Link to={fromUrl}>
          {fromUrl.startsWith("/auditBrowser")
            ? "Audit Browser"
            : "Section Browser"}
        </Link>
        <BreadCrumbLayout />
      </div>

      <div className="audit-right">
        <div
          className="action d-flex gap-2 align-items-center"
          onClick={() => setShow(true)}
        >
          <p className="m-0 expo">Create Action</p>
          <img src={ActionImg} alt="img" />
        </div>

        <div className="export-container" ref={exportRef}>
          <Tooltip
            title={!isReportReady ? "Please wait, report is loading..." : ""}
          >
            <div
              className={`export d-flex gap-2 align-items-center ${!isReportReady ? "export-disabled" : ""}`}
              onClick={() => isReportReady && setIsOpen(!isOpen)}
            >
              <p className="m-0 expo">Export To</p>
              <img src={downDrop} alt="dropdown icon" />
            </div>
          </Tooltip>
          {isOpen && (
            <ul className="dropdown-menu show no-print p-0">
              <li onClick={handleDownloadExcel}>Excel Report</li>
              <li onClick={handlePrintDetails}>Print Report</li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default ARHeaderActions;
